import React from 'react';
import React3 from 'react-three-renderer';
import THREE from 'three';
import ReactDOM from 'react-dom';
import clickDrag from 'react-clickdrag';

class GlobeChartGlobe extends React.Component {
    constructor(props, context) {
        super(props, context);

        // construct the position vector here, because if we use 'new' within render,
        // React will think that things have changed when they have not.
        this.cameraPosition = new THREE.Vector3(0, 0, 3.3);
        this.state = {
            rotation: props.startRotation || 0,
            lastDeltaX:0,
        };    
    }
    componentWillReceiveProps(nextProps) {
        
        if(nextProps.dataDrag.isMouseDown && !nextProps.dataDrag.isMoving) {
            this.setState({
                lastDeltaX: 0
            });
        }
        
        if(nextProps.dataDrag.isMoving) {
            console.log(nextProps.dataDrag.moveDeltaX);
            this.setState({
                rotation: Math.round(this.state.rotation + (nextProps.dataDrag.moveDeltaX - this.state.lastDeltaX)),
                lastDeltaX: nextProps.dataDrag.moveDeltaX
            });
        } 
    }
    
    render() {
        const width = this.props.width || this.context.containerWidth || 500; 
        const height = this.props.height || this.context.containerWidth || 500; 
        const segments = 40;
        return <React3
            mainCamera="camera" // this points to the perspectiveCamera which has the name set to "camera" below
            width={width}
            height={height}
            clearAlpha = {0}
            alpha={true}
            precision="highp"
            antialias
            >
            <resources>
                <texture
                    resourceId="texture"
                    url={this.props.texture}
                    wrapS = {THREE.ClampToEdgeWrapping}
                    wrapT = {THREE.ClampToEdgeWrapping}
                    anisotropy={16}
                />
                <meshPhongMaterial
                    resourceId="material"
                    side={THREE.DoubleSide}
                >
                    <textureResource
                    resourceId="texture"
                    />
                </meshPhongMaterial>
            </resources>
            <scene>
                <ambientLight
                    color={0x777777}
                />
                <directionalLight
                    color={0x888888}
                    position={new THREE.Vector3(10, 18, 20)}
                />
                <perspectiveCamera
                name="camera"
                fov={15}
                aspect={width / height}
                near={0.1}
                far={1000}

                position={this.cameraPosition}
                />
                <mesh
                rotation={new THREE.Euler(25 * Math.PI/180,this.state.rotation*Math.PI/180,0)}
                position={new THREE.Vector3(0,0,-12)}
                >
                    <sphereGeometry
                        radius={2}
                        widthSegments={segments}
                        heightSegments={segments}
                    />
                    <materialResource
                        resourceId="material"
                    />
                </mesh>
            </scene>
        </React3>;    
        
        
        
        
    }
}
// fov = 30 -4.5 
GlobeChartGlobe.contextTypes = {
    containerWidth: React.PropTypes.number,
    containerHeight: React.PropTypes.number
};

export default clickDrag(GlobeChartGlobe, {touch: true })


// WEBPACK FOOTER //
// ./src/js/components/special/GlobeChart/GlobeChartGlobe.jsx